<template>
  <div class="col-12 col-md-12 col-lg-7 text-center">
    <div class="tit">
      <p>A(O) <strong>{{razaoSocial}}</strong> possui contador?</p>
    </div>
    <div class="text-center fixedOptions">
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithAccountant">Sim</button>
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithoutAccountant">Não</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    submitWithAccountant() {
      this.$emit('on-submit', {Empresa: {TemContador: true}})
    },
    submitWithoutAccountant() {
      this.$emit('on-submit', {Empresa: {TemContador: false, Contador: null}})
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/HasAccountantStep.vue